// extracted by mini-css-extract-plugin
export default {"wrp":"DocumentVersions_wrp__c07uq","title":"DocumentVersions_title__hLsVc"};